export const validEmailRegex = RegExp(
  /^[_a-z0-9]+(\.[_a-z0-9]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})$/
);

export const validPhoneNumberRegex = RegExp(
  /^(?:\(\d{3}\)|\d{3})[- ]?\d{3}[- ]?\d{4}$/
);

export const validZipCodeRegex = RegExp(/^[0-9]{5}$/);
